import React from 'react';
import t from 'prop-types';

var EntradaTipoVolverAMenu = function EntradaTipoVolverAMenu(_ref) {
  var texto = _ref.texto,
      onClick = _ref.onClick;
  return React.createElement('div', {
    className: 'volverAMenu',
    onClick: onClick
  }, texto && React.createElement('span', {
    dangerouslySetInnerHTML: {
      __html: texto
    }
  }));
};

EntradaTipoVolverAMenu.propTypes = process.env.NODE_ENV !== "production" ? {
  texto: t.string,
  clase: t.string,
  onClick: t.func
} : {};
export default EntradaTipoVolverAMenu;